import React from "react";

// Statuts du Comparatif Geotab, communs à Rapports et à la liste Geotab du Dispatch.
// Couleurs des pastilles Geotab : brique, ocre, ardoise, vert.
const GEOTAB_ORDER_STATUSES = {
  missing: { label: "Aucun arrêt", className: "border-[#c5524a] bg-[#c5524a] text-white" },
  other: { label: "Autre camion", className: "border-[#a86a24] bg-[#a86a24] text-white" },
  check: { label: "Loin de l’adresse", className: "border-[#3f5585] bg-[#3f5585] text-white" },
  unknown: { label: "Sans position", className: "border-slate-500 bg-slate-500 text-white" },
  found: { label: "Arrêt détecté", className: "border-[#0f5c57] bg-white text-[#0f5c57]" },
};

// Écarts vus par Geotab, dans la liste Geotab du Dispatch : commande sans tournée, Chargé PM non prévu, arrêt hors du
// Dispatch (sans commande), site prévu pas vu.
const GEOTAB_GAP_BADGES = {
  unassigned: { label: "Sans tournée", className: "border-[#9c3b31] bg-[#9c3b31] text-white" },
  pm: { label: "Chargé PM", className: "border-[#f2c94c] bg-[#f2c94c] text-slate-900" },
  none: { label: "Hors Dispatch", className: "border-[#6d4c9f] bg-[#6d4c9f] text-white" },
  missed: { label: "Pas vu", className: "border-[#b91c1c] bg-[#b91c1c] text-white" },
};

const badgeOf = (status) => GEOTAB_ORDER_STATUSES[status] || GEOTAB_GAP_BADGES[status] || GEOTAB_ORDER_STATUSES.unknown;

export default function GeotabOrderStatusBadge({ status }) {
  const { label, className } = badgeOf(status);
  return <span className={`inline-flex h-[18px] w-[106px] flex-none items-center justify-center rounded-[4px] border text-[10.5px] font-bold ${className}`}>{label}</span>;
}
